<template>
  <div v-if="achievements.length" class="trainer-achievements">
    <div v-for="el in achievements" :key="el.id" class="line-info">
      <span>
        <i class="icon-event" />
        {{ $t('common.event_and_status') }}
      </span>
      <p>
        {{ el.event }}
      </p>
      <span>
        <i class="icon-event-place" />
        {{ $t('common.event_location') }}
      </span>
      <p>
        {{ el.place }}
      </p>
    </div>
  </div>
  <div v-else class="no-info">
    <div class="line-info">
      <p>{{ $t('common.no_trainer_achievement') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Achievements',
  props: {
    achievements: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/css/variables';

.trainer-achievements {
  .line-info {
    &:first-child {
      &:before {
        display: none;
      }
    }

    &:before {
      content: '';
      display: block;
      height: 1px;
      background-color: #f0f0f0;
      margin: 5px 0;
    }
  }
}

@media (min-width: 768px) {
  .trainer-achievements {
    .line-info {
      flex-wrap: wrap;
      margin-bottom: 35px;

      &:last-child {
        margin-bottom: 0;
      }

      span {
        height: auto;
        padding: 10px 0;
        align-items: unset;
      }

      p {
        width: 75%;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
